import { FaFacebookF, FaInstagram, FaTiktok, FaYoutube, FaTwitter, FaLinkedinIn, FaWhatsapp } from 'react-icons/fa';

// Réseaux sociaux administrables — clé alignée avec l'admin (badminton-club-eragny-admin/src/pages/Contact.jsx).
export const PLATFORM_META = {
  facebook:  { icon: FaFacebookF, label: 'Facebook' },
  instagram: { icon: FaInstagram, label: 'Instagram' },
  tiktok:    { icon: FaTiktok,    label: 'TikTok' },
  youtube:   { icon: FaYoutube,   label: 'YouTube' },
  twitter:   { icon: FaTwitter,   label: 'Twitter / X' },
  linkedin:  { icon: FaLinkedinIn, label: 'LinkedIn' },
  whatsapp:  { icon: FaWhatsapp,  label: 'WhatsApp' },
};

// Affiche l'URL sans protocole ni slash final, pour un rendu plus lisible qu'un lien brut.
export const displayUrl = (url) => (url || '').replace(/^https?:\/\//, '').replace(/\/$/, '');
